import Button from '@mui/material/Button'
import EditIcon from '../../../icons/editIcon'
import { Box, SxProps, Theme, useMediaQuery } from '@mui/material'
interface Props {
  sx?: SxProps<Theme>
  handleClick: () => void
}

const EditButton = ({ sx, handleClick }: Props) => {
  const isSmallMobile = useMediaQuery('(max-width: 480px)')
  const isMobile = useMediaQuery('(max-width: 800px)')
  
  return (
    <Button
      sx={{
        p: '0',
        minWidth: isSmallMobile ? '40px' : isMobile ? '45px' : '50px',
        minHeight: isSmallMobile ? '40px' : isMobile ? '45px' : '50px',
        backgroundColor: 'secondary.main',
        color: 'white',
        borderRadius: '0',
        transformOrigin: 'left',
        transition: '0.5s ',
        display: 'flex',
        alignItems: 'center',
        fontSize: isSmallMobile ? '12px' : '14px',
        '&:hover': {
          backgroundColor: 'primary.main',
          width: isSmallMobile ? '120px' : isMobile ? '130px' : '135px',
        },
        '&:hover div': {
          display: 'block',
        },
        ...sx,
      }}
      onClick={handleClick}
    >
      <EditIcon />
      <Box sx={{ ml: '18px', display: 'none' }}>éditer</Box>
    </Button>
  )
}

export default EditButton
